import React from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "trumbowyg/dist/ui/trumbowyg.min.css";
import "trumbowyg/dist/trumbowyg.min.js";
import "trumbowyg/dist/plugins/table/trumbowyg.table.min.js";
import "trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { createRoot } from "react-dom/client";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { createStore, applyMiddleware, compose } from "redux";
import App from "./App";
import axios from "./axios-defaults";
import "./index.css";
import ErrorBoundary from "./main/components/ErrorBoundry/ErrorBoundry";
import reportWebVitals from "./reportWebVitals";
// Service worker registration is handled in App.js
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";
import Reducer from "./store";
import { thunk } from "redux-thunk";

// Initialize Sentry only if DSN is provided
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: process.env.REACT_APP_SENTRY_ENV || "development",
    tracesSampleRate: 1.0,
  });
} else {
  console.log("Sentry DSN not configured, skipping Sentry initialization");
}

const token = localStorage.getItem("access_token");
const customToken = localStorage.getItem("x-auth-token");
if (token) {
  axios.defaults.headers.common["Authorization"] =
    `Bearer ${localStorage.getItem("access_token")}`;
}
if (customToken) {
  /* axios.defaults.headers.common["X-Custom-Information"] =
    "Bearer " + customToken; */
}

const middleware = [thunk];

// Redux DevTools Extension support
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  Reducer,
  composeEnhancers(applyMiddleware(...middleware))
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Service worker is registered in App.js with proper update handling
// serviceWorkerRegistration.register();

reportWebVitals();
